import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { Dialog, Item } from '@zebra-fed/zds-react-desktop';
import TextField from '@material-ui/core/TextField';
import ShowPassword from '../ShowPassword';
import {useTranslation} from "react-i18next";

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const ElementWrapper = styled.div`
    display: flex;
    padding-top: 8px;
`

const MainContent = styled.div`
    width: 520px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 28px;
`

const SubHeader = styled.div`
    font-size: 14px;
    display: flex;
    align-self: flex-start;
    color: #4C4C4C;
    padding-left: 70px;
`

const StyledTextField = styled(TextField)`
    width: 380px;
    display: flex;
`;

export default function ChangePasswordModal(props) {
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConf, setShowPasswordConf] = useState(false);
    const [checkErrors, setCheckErrors] = useState(false);

    const errors = useRef([]);

    const dialogRef = props.modalRef;

    const {t} = useTranslation()

    function onSubmit() {
        errors.current = [];
        if (newPassword.trim() === "") {
            errors.current = errors.current.concat('password');
        }
        if (newPassword.match("^[A-Za-z0-9!@#$%&]*$") === null) {
            errors.current = errors.current.concat('invalidPassword');
        }
        if (newPassword !== confirmNewPassword) {
            errors.current = errors.current.concat('password match');
        }
        if (newPassword.length < 6 || newPassword.length > 25) {
            errors.current = errors.current.concat('password length');
        }
        setCheckErrors(!checkErrors);
        if (errors.current.length === 0) {
            // TODO: firebase call goes here
            // TODO: add error snack bar which appears here 
        }
    }

    function onCancel() {
        dialogRef.current.toggleDialog();
        clearForm();
    }

    function clearForm() {
        setNewPassword('');
        setConfirmNewPassword('');
    }

    return (
        <>
            <Dialog ref={dialogRef}
                key='dialog2'
                width='520px'
            
                items={[
                    <Item type='button' style={{backgroundColor: '#757575', width: '102px'}} onClick={() => onCancel()}>{t('cancel')}</Item>,
                    <Item type='button' onClick={() => onSubmit()}>{t('resetPassword')}</Item>
                ]}
                headerStyle={{display: 'none' }}
                bodyStyle={{padding: '0px'}}
                footerStyle={{padding: '52px 24px 24px 24px'}}
            >
                <ModalHeader>
                    {t('changePassword')}
                </ModalHeader>
                <MainContent>
                    <SubHeader>
                        <i>Change Password for {props.currentUser && props.currentUser.email}</i>
                    </SubHeader>
                    <ElementWrapper>
                        <StyledTextField
                            error={errors.current.length > 0}
                            label={t('newPassword')}
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            type={showPassword ? "text" : "password"}
                            autoComplete="new-password"
                            helperText={
                                errors.current.includes('password') ? t('validation.rules.passwordValidation1') :
                                errors.current.includes('password length') ? t('validation.rules.passwordValidation2') :
                                errors.current.includes('invalidPassword') ? t('validation.rules.passwordValidation3') :  ''
                            }
                            InputProps={{ 
                                endAdornment: <ShowPassword showPassword={showPassword} onClick={() => setShowPassword(!showPassword)} size={25}/>
                            }}
                        />
                    </ElementWrapper>
                    <ElementWrapper>
                        <StyledTextField
                            error={errors.current.includes('password match')}
                            label= {t('confirmPassword')}
                            value={confirmNewPassword}
                            onChange={(e) => setConfirmNewPassword(e.target.value)}
                            type={showPasswordConf ? "text" : "password"}
                            autoComplete="new-password"
                            helperText={errors.current.includes('password match') ? t('messages.error.err40') : null}
                            InputProps={{ 
                                endAdornment: <ShowPassword showPassword={showPasswordConf} onClick={() => setShowPasswordConf(!showPasswordConf)} size={25}/>
                            }}
                        />
                    </ElementWrapper>
                </MainContent>
            </Dialog>
        </>
    )
}